"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _information = _interopRequireDefault(require("@ux/icon/information"));
var _ToolTipWrapper = require("./ToolTipWrapper");
var _AccessibilityConstants = require("./constants/AccessibilityConstants");
var _EidCodes = _interopRequireDefault(require("./constants/EidCodes"));
var _PackageSection = require("./styles/PackageSection");
const PackageSection = ({
  features = [],
  eid
}) => /*#__PURE__*/_react.default.createElement(_PackageSection.PackageContents, null, features.map((feature, i) => /*#__PURE__*/_react.default.createElement("div", {
  key: i,
  className: "d-flex justify-content-start align-items-start",
  "data-cy": "feature-bullet"
}, /*#__PURE__*/_react.default.createElement("span", {
  className: "text-primary-o feature-bullet"
}, '+'), /*#__PURE__*/_react.default.createElement(_PackageSection.StyledFeatureWrapper, null, /*#__PURE__*/_react.default.createElement("span", null, feature.featText), feature.tooltip && /*#__PURE__*/_react.default.createElement(_PackageSection.InfoIconWrapper, {
  "data-testid": `feature-tooltip-${i}`
}, /*#__PURE__*/_react.default.createElement(_ToolTipWrapper.TooltipWrapper, {
  id: _AccessibilityConstants.TOOLTIP_ID.DEFAULT,
  dataEid: `${eid}.${_EidCodes.default.FeatureTooltipClick}.${i}.click`,
  tooltipButtonText: /*#__PURE__*/_react.default.createElement("span", {
    className: "info-icon"
  }, /*#__PURE__*/_react.default.createElement(_information.default, {
    width: 11,
    height: 15
  })),
  tooltipContent: feature.tooltip
}))))));
PackageSection.propTypes = {
  features: _propTypes.default.arrayOf(_propTypes.default.shape({
    featText: _propTypes.default.string,
    tooltip: _propTypes.default.string
  })),
  eid: _propTypes.default.string
};
var _default = exports.default = PackageSection;